'use client'

import { createContext, useState, useEffect } from 'react'

const NotificationContext = createContext()

const NotificationProvier = ({ children }) => {

  const [notification, setNotification] = useState(5);
  const [loadingNotification, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const simulateFetch = async () => {
      setLoading(true)
      try {
        await new Promise((resolve) => setTimeout(resolve, 7000))
        setNotification(5)
      } catch (err) {
        setError("Erro ao buscar notificações")
      } finally {
        setLoading(false)
      }
    }

    simulateFetch()
  }, [])

  return (
    <NotificationContext.Provider
      value={{
        notification,
        loadingNotification,
        error,
      }}
    >
      <>{children}</>
    </NotificationContext.Provider>
  );
};

export { NotificationContext, NotificationProvier };